import * as storage from '@shared/utils/storage/common'

type PutParams = Parameters<typeof storage.put>
export function put(key: PutParams[0], value: PutParams[1]) {
  return storage.put(key, value, 'local')
}

type getParams = Parameters<typeof storage.get>
export function get<T>(key: getParams[0], defaultValue?: getParams[1]) {
  return storage.get<T>(key, defaultValue, 'local')
}

type removeParams = Parameters<typeof storage.remove>
export function remove(key: removeParams[0]) {
  return storage.remove(key, 'local')
}

export function clear() {
  return storage.clear('local')
}
